import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HotSeries from "./components/HotSeries";
import LatestNews from "./components/LatestNews";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useSeo({
    title: "仙剑奇侠传影视站-经典仙侠剧全集与剧情介绍",
    description:
      "仙剑奇侠传网站提供丰富的仙侠电视剧资源，包括剧情介绍、角色分析和最新资讯，满足粉丝对经典仙侠剧的多方位需求。",
    keywords: "仙剑奇侠传,仙侠剧,仙剑奇侠传剧情,仙剑奇侠传电视剧,古装剧,仙侠影视,经典电视剧。",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar transparentTop />
      <main>
        <HeroCarousel />
        <CategoryEntries />
        <HotSeries />
        <LatestNews />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}